<div class="app-input">
  <mat-form-field [formGroup]="group" class="full-width-field">
    <mat-label>{{field.displayName}}</mat-label>
    <input matInput
           [matAutocomplete]="auto"
           [formControl]="catalogCtrl"
           (blur)="checkCatalog()">
    <mat-autocomplete #auto="matAutocomplete">
      @for (catalogResource of filteredCatalogs | async; track catalogResource) {
        <mat-option [value]="getDisplay(catalogResource)" (onSelectionChange)="catalogSelected($event, catalogResource)">
          <span>{{catalogResource.description}}</span>
        </mat-option>
      }
    </mat-autocomplete>
    <input [formControlName]="field.name" type="hidden" [value]="field.value">
  </mat-form-field>
</div>
